import { PartialImpressum } from "../Partial/PartialImpressum";
import { PartialAboutMePage } from "../Partial/PartialAboutMePage";
import { PartialContactPage } from "../Partial/PartialContactPage";
import { PartialHomePage } from "../Partial/PartialHomePage";
import { PartialProjectsPage } from "../Partial/PartialProjectsPage";
import { PartialPrivacyPolicy } from "../Partial/PartialPrivacyPolicy";

export const Main = ({component}:{component:string}) => {
    
    const renderPartial = (component:string) => {
        switch(component){
            
            case PartialHomePage.toString():{
                return <PartialHomePage />;
            }
            case PartialAboutMePage.toString(): {
                return <PartialAboutMePage />;
            }
            case PartialProjectsPage.toString():{
                return <PartialProjectsPage />;
            }
            case PartialContactPage.toString():{
                return <PartialContactPage />;
            }
            case PartialImpressum.toString():{
                return <PartialImpressum />;
            }
            case PartialPrivacyPolicy.toString():{
                return <PartialPrivacyPolicy />;
            }
            default: {
                return null;
            }
        }
    }
    
    return(
        <div>
            {
                renderPartial(component)
            }
        </div>
    )
}